package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.lerp
import ru.chm.gradereport.ui.theme.GradeTheme
import ru.chm.gradereport.ui.theme.GreenAccent
import ru.chm.gradereport.ui.theme.RedAccent
import kotlin.math.roundToInt

/** 2 → red, 5 → green; outside that range clamped. */
internal fun gradeColor(score: Double): Color {
    val t = ((score - 2.0) / 3.0).toFloat().coerceIn(0f, 1f)
    return lerp(RedAccent, GreenAccent, t)
}

@Composable
internal fun gradeColorOrMuted(score: Double?): Color =
    score?.let { gradeColor(it) } ?: GradeTheme.colors.textMuted

internal fun gradeOptions(maxScore: Double): List<Int> {
    val max = maxScore.roundToInt().coerceAtLeast(1)
    return (1..max).toList()
}
